<div class="countContainer" [ngClass]="{'vertical': isVertical, 'horizontal': !isVertical}">
  <div class="count countThree"><span>3</span></div>
  <div class="count countTwo"><span>2</span></div>
  <div class="count countOne"><span>1</span></div>
  <div class="count countCam"><i class="icon icon-camera"></i></div>
</div>
